// extracted by mini-css-extract-plugin
export default {"dewar":"Dewar_dewar__ynS-P","separator":"Dewar_separator__dV+DN","action":"Dewar_action__e4xFT"};